let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

//eye patch button restrictions

$(document).ready(function () {
    const cappedVariantId = 42388327399589; // The variant ID you are working with
    const cappedProductId = 8200966963365;  // The product ID
    let isProcessing = false;

    // Handle the add-to-cart button click
    $(document).on("click", ".devx_eye_patch", function (e) {
      e.preventDefault();

      const variantId = $(this).find(".dev_home_getvariantid").val();

      if (!variantId || isProcessing) {
        return;
      }

      const button = $(this).find("button");
      isProcessing = true;
      button.prop("disabled", true);

      // Check if the clicked product's variant is the capped variant
      if (variantId == cappedVariantId) {
        $.getJSON("/cart.js", function (cart) {
          const productInCart = cart.items.some(
            (item) => item.variant_id == cappedVariantId
          );

          // If the product is already in the cart, show the popup and stop adding it again
          if (productInCart) {
            $(".popup-overlay").show(); // Show the popup
            isProcessing = false;
            button.prop("disabled", false);
          } else {
            // If the product isn't in the cart, add it
            addProductToCart(variantId, 1, button);
          }
        }).fail(function () {
          isProcessing = false;
          button.prop("disabled", false);
        });
      } else {
        // If it's not the capped variant, simply add it to the cart
        addProductToCart(variantId, 1, button);
      }
    });

    // Function to add product to the cart
    function addProductToCart(variantId, quantity = 1, button) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: variantId, quantity: quantity },
        dataType: "json",
        success: function () {
          updateCartDrawer(); // Update cart drawer after product is added
        },
        error: function (xhr) {
          console.error("Error:", xhr.responseText);
        },
        complete: function () {
          isProcessing = false;
          button.prop("disabled", false);
        },
      });
    }

    // Function to dynamically update the cart drawer
    function updateCartDrawer() {
        fetch(`/?section_id=${window.section2}`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.text();
          })
          .then((html) => {
            document.getElementById(`shopify-section-${section2}`).innerHTML = html;
            $("cart-drawer#cart-drawer-unique").addClass("active");
            console.log('Cart section reloaded successfully.');
            updateCartIconBubble();
          });
    }

    // Function to update the cart icon bubble
   function updateCartIconBubble() {
    $.getJSON("/cart.js", function (cart) {
        const totalItems = cart.item_count;
        $('.dev_desktop_cart_icon').append(`
            <div class="cart-count-bubble">
                <span aria-hidden="true">${totalItems}</span>
                <span class="visually-hidden">${totalItems} items</span>
            </div>
        `);
    });
}
 
  });


//devex code add to cart section //
document.addEventListener("DOMContentLoaded", function () {
    // Check if the cart drawer should be opened
    const openCart = localStorage.getItem('openCartDrawer');

    if (openCart === 'true') {
        const cartDrawer = document.querySelector("cart-drawer#cart-drawer-unique");

        if (cartDrawer) {
            // Add the active class
            cartDrawer.classList.add("active");

            // Trigger any related UI events
            if (typeof $ !== 'undefined') {
                $("cart-drawer#cart-drawer-unique").trigger("open.drawer");
            }

            // Dispatch a custom event if needed
            const openEvent = new Event("drawer:open");
            cartDrawer.dispatchEvent(openEvent);
        } else {
            console.error("Cart drawer element not found.");
        }

        // Clear the flag from localStorage to prevent repeated opening
        localStorage.removeItem('openCartDrawer');
    }
});
  
  $(document).on('click', '.devx_add_to_cart_button', function(e) {
    document.getElementById('cart-icon-bubble').click();
});


    // when hit this url (https://www.dotandkey.com/?cart=open) cart will open
    //It is Auto open cart drawer for seo hit page (Moumita/Biswajit)
    // Function to get the value of a query parameter by name

  //     $(document).ready(function () {
  //       function getQueryParam(param) {
  //           const urlParams = new URLSearchParams(window.location.search);
  //           return urlParams.get(param);
  //       }
    
  //       const cartValue = getQueryParam('cart');
  //       console.log('cartValue:', cartValue); // Debugging

  //         // use this code when we are using upcart
  //         // const upcartPopup = document.getElementById('UpcartPopup');
  //         // const CartPopup = document.getElementById('CartPopup');
    
  //         // if (upcartPopup) {
  //         //   upcartPopup.classList.add('upcartPopupShow');
  //         //   CartPopup.classList.add('styles_active__');
  //         // }
  //   if (cartValue === 'open') {
  //           setTimeout(function () {
  //               const $cartDrawerUnique = $("#cart-drawer-unique"); // Correct jQuery selector
  //               console.log('cartDrawerUnique:', $cartDrawerUnique); // Debugging
    
  //              if ($cartDrawerUnique.length) {
  //                 // Apply the styles
  //                 $cartDrawerUnique.addClass("active");
  
  //                 // **Force reflow & repaint for mobile responsiveness**
  //                 $cartDrawerUnique[0].offsetHeight; // Trigger reflow
  //                 requestAnimationFrame(() => {
  //                     $cartDrawerUnique.addClass("force-redraw"); // Temporary class to force reflow
  //                     setTimeout(() => {
  //                         $cartDrawerUnique.removeClass("force-redraw"); // Cleanup after redraw
  //                     }, 50);
  //                 });
  
  //                 // **Fix for mobile by triggering a small scroll**
  //                 setTimeout(() => {
  //                     window.scrollBy(0, 1); // Small scroll to trigger layout update
  //                     window.scrollBy(0, -1);
  //                 }, 100);
  
  //                 console.log('Class added and visibility set successfully!');
  //             } else {
  //                 console.warn('Element with ID "cart-drawer-unique" not found.');
  //             }
  //           }, 1500);
  //       }
  //   });
  // //end  





  
 <!-- open cart -->
  $(document).on("click", "#cart-icon-bubble.header__icon", function () {
    $("cart-drawer#cart-drawer-unique").addClass("active");
  });
$(document).ready(function () {
  function updateCartCount() {
    $.getJSON("/cart.js", function (cart) {
      var itemCount = cart.item_count;
      var $cartBubble = $(".count-mobile-cart .cart-count");
      var $cartHiddenText = $(".count-mobile-cart .visually-hidden");

      if (itemCount > 0) {
        $cartBubble.text(itemCount);
        $cartHiddenText.text(itemCount + " items");
        $(".count-mobile-cart").show();
      } else {
        $(".count-mobile-cart").hide();
      }
    });
  }

  updateCartCount();
  setInterval(updateCartCount, 1000);

  // Event Delegation for Dynamic Elements
  $(document).on("click", "#cart-icon-bubble", function () {
    if (typeof window.handleFloCartBtn === "function") {
      window.handleFloCartBtn();
    }
  });
});

$(document).ready(function () {
  function updateCartCount() {
    $.getJSON("/cart.js", function (cart) {
      var itemCount = cart.item_count;
      var $cartIcon = $(".mob_count");
      if (!$cartIcon.find(".cart-count-bubble").length) {
        console.log("Cart bubble not found, creating...");
        $cartIcon.append('<div class="cart-count-bubble count-mobile-cart"><span aria-hidden="true" class="cart-count"></span><span class="visually-hidden"></span></div>');
      }
      var $cartBubble = $cartIcon.find(".cart-count-bubble .cart-count");
      var $cartHiddenText = $cartIcon.find(".cart-count-bubble .visually-hidden");

      if (itemCount > 0) {
        $cartBubble.text(itemCount);
        $cartHiddenText.text(itemCount + " items");
        $(".cart-count-bubble").show();
      } else {
        $(".cart-count-bubble").hide();
      }
    });
  }

  // Observe body for dynamic changes (in case .mob_count loads late)
  let cartObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if ($(mutation.target).find(".mob_count").length) {
        updateCartCount(); 
      }
    });
  });
  cartObserver.observe(document.body, { childList: true, subtree: true });
  updateCartCount();
  setInterval(updateCartCount, 1000);
});

$(document).ready(function () {
  function updateCartCount() {
    $.getJSON("/cart.js", function (cart) {
      var itemCount = cart.item_count;
      var $cartBubble = $(".count-mobile-cart .cart-count");
      var $cartHiddenText = $(".count-mobile-cart .visually-hidden");

      if (itemCount > 0) {
        $cartBubble.text(itemCount);
        $cartHiddenText.text(itemCount + " items");
        $(".count-mobile-cart").show(); // Ensure bubble is visible
      } else {
        $(".count-mobile-cart").hide(); // Hide bubble when cart is empty
      }
    });
  }

  // Initial update
  updateCartCount();
  setInterval(updateCartCount, 1000);
});





